export default {
  user(state) {
    return state.user;
  },
  loading(state) {
    return state.loading;
  },
  hasRoleAdmin(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map((r) => r.name).includes('ROLE_FORNECEDOR_ADMIN');
  },
};
